import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";

// Firebase web config is PUBLIC by design — Firebase docs explicitly say
// these values are not secrets. Apply restrictions in the Firebase console
// (authorized domains + API key referrer restrictions). Hardcoding lets us
// avoid the build-time env-var dance for client-side keys.
const STAGE_CONFIG = {
  apiKey: "AIzaSyAObenR2x63jhZdwZAWUx87u762nv_P2OI",
  authDomain: "foto-stage.firebaseapp.com",
  projectId: "foto-stage",
  appId: "1:602870976668:web:d2be470a03490a9e9ddd59",
};

const PROD_CONFIG = {
  apiKey: "AIzaSyBT2P4edRfeZ6mZsNQWdAm5Pm54okGyId8",
  authDomain: "foto-prod-cda4c.firebaseapp.com",
  projectId: "foto-prod-cda4c",
  appId: "1:149701662408:web:db25e149406927659037fd",
};

function pickConfig() {
  // Server-side render: no window. Default to stage so prod tokens never
  // leak into a misconfigured render. Auth flow only runs client-side anyway.
  if (typeof window === "undefined") return STAGE_CONFIG;
  const host = window.location.hostname;
  // Stage and local dev → stage project. Anything else → prod (fotodelavnica.si,
  // fotoradnja.hr, fotospomienky.sk, foto-chwila.pl, etc.)
  const isStage =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.includes(".stage.") ||
    host.startsWith("stage.");
  return isStage ? STAGE_CONFIG : PROD_CONFIG;
}

let _app: FirebaseApp | null = null;
let _auth: Auth | null = null;

function getFirebaseApp(): FirebaseApp {
  if (_app) return _app;
  if (getApps().length > 0) {
    _app = getApps()[0];
    return _app;
  }
  _app = initializeApp(pickConfig());
  return _app;
}

export function getFirebaseAuth(): Auth {
  if (_auth) return _auth;
  _auth = getAuth(getFirebaseApp());
  return _auth;
}
